import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const signupSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .min(6, "Minimum 6 characters")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  referral: yup.string().optional(),
});

const SignupForm = ({ onSubmit, switchToLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signupSchema),
  });

  return (
    <>
      <h1 className="auth-title">Create an account</h1>
      <p className="auth-subtitle">Enter your details below</p>

      <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
        <div className="form-field">
          <input type="text" placeholder="Name" {...register("name")} />
          {errors.name && <p className="error">{errors.name.message}</p>}
        </div>
        <div className="form-field">
          <input type="email" placeholder="Email" {...register("email")} />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>
        <div className="form-field">
          <input
            type="password"
            placeholder="Password"
            {...register("password")}
          />
          {errors.password && (
            <p className="error">{errors.password.message}</p>
          )}
        </div>
        <div className="form-field">
          <input
            type="password"
            placeholder="Confirm Password"
            {...register("confirmPassword")}
          />
          {errors.confirmPassword && (
            <p className="error">{errors.confirmPassword.message}</p>
          )}
        </div>
        <div className="form-field">
          <input
            type="text"
            placeholder="Referral (optional)"
            {...register("referral")}
          />
        </div>
        <button type="submit" className="submit-button">
          Create Account
        </button>
        <div className="auth-footer">
          <span>Already have an account? </span>
          <a onClick={switchToLogin} className="login-link">
            Log in
          </a>
        </div>
      </form>
    </>
  );
};

export default SignupForm;
